import { connect } from 'redux-bundler-react';
import React from 'react';

import PusherSubscription from '../../atoms/PusherContainer/PusherSubscription';

const CHANNEL = 'private-deploy-status';
const EVENT = 'deploy_status_changed';

const DeployProgressPusherWiring = ({
  deployProgressBranch: branch,
  doDeployProgressEvent,
  doDevSimulateDeploy,
}) => {
  React.useEffect(() => {
    if (!branch || branch === 'local') {
      // eslint-disable-next-line no-console
      console.log(
        `[deploy-progress] skipping Pusher subscription (branch=${branch})`,
      );
      return;
    }
    // eslint-disable-next-line no-console
    console.log(
      `[deploy-progress] mounting subscription channel="${CHANNEL}" event="${EVENT}" branch="${branch}"`,
    );
  }, [branch]);

  React.useEffect(() => {
    window.__simulateDeploy = doDevSimulateDeploy;
    window.__simulateDeployBurst = () => {
      doDevSimulateDeploy('building');
      setTimeout(() => doDevSimulateDeploy('succeeded'), 600);
    };
    return () => {
      if (window.__simulateDeploy === doDevSimulateDeploy) {
        delete window.__simulateDeploy;
      }
      delete window.__simulateDeployBurst;
    };
  }, [doDevSimulateDeploy]);

  if (!branch || branch === 'local') return null;

  const handleUpdate = payload => {
    // eslint-disable-next-line no-console
    console.log('[deploy-progress] event received:', payload);
    doDeployProgressEvent(payload);
  };

  return (
    <PusherSubscription
      channelName={CHANNEL}
      eventName={EVENT}
      onUpdate={handleUpdate}
    />
  );
};

export default connect(
  'selectDeployProgressBranch',
  'doDeployProgressEvent',
  'doDevSimulateDeploy',
  DeployProgressPusherWiring,
);
